import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manual',
  templateUrl: './manual.component.html',
  styleUrls: ['./manual.component.css'],
})
export class ManualComponent implements OnInit {
  manual: string =
    'https://firebasestorage.googleapis.com/v0/b/colegia-education-demo.firebasestorage.app/o/Manuales%2FManual_Alumno_Colegia(ESP).pdf?alt=media&token=98d3e570-d2ea-4b91-9e8e-277d419f48b9';
  idioma = 'es';
  constructor() {}

  ngOnInit(): void {
    if (localStorage.getItem('lenguaje')) {
      this.idioma = localStorage.getItem('lenguaje');
    }
    switch (this.idioma) {
      case 'es':
        this.manual =
          'https://firebasestorage.googleapis.com/v0/b/colegia-education-demo.firebasestorage.app/o/Manuales%2FManual_Alumno_Colegia(ESP).pdf?alt=media&token=98d3e570-d2ea-4b91-9e8e-277d419f48b9';
        break;

      default:
        this.manual =
          'https://firebasestorage.googleapis.com/v0/b/colegia-education-demo.firebasestorage.app/o/Manuales%2FManual_Alumno_Colegia(ESP).pdf?alt=media&token=98d3e570-d2ea-4b91-9e8e-277d419f48b9';
        break;
    }
  }
}
